import { render, staticRenderFns } from "./listaPartidas.vue?vue&type=template&id=772ed9e9&scoped=true"
import script from "./listaPartidas.vue?vue&type=script&lang=js"
export * from "./listaPartidas.vue?vue&type=script&lang=js"
import style0 from "./listaPartidas.vue?vue&type=style&index=0&id=772ed9e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772ed9e9",
  null
  
)

export default component.exports